module.exports = __webpack_public_path__ + "img/Colombia.f6b8ff59.png";